// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const ADD_APPLICATION_SETTINGS = 'ADD_APPLICATION_SETTINGS'
